import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import { forwardRef } from 'react';

// shorthand props created for convenience
type FlexProps = {
    direction?: BoxProps['flexDirection'];
    align?: BoxProps['alignItems'];
    justify?: BoxProps['justifyContent'];
    wrap?: BoxProps['flexWrap'];
};

const Flex = forwardRef<HTMLDivElement, BoxProps & FlexProps>((props, ref) => {
    const {
        // shorthand
        direction,
        align,
        justify,
        wrap,
        // BoxProps full length props
        flexDirection,
        alignItems,
        justifyContent,
        flexWrap,
        ...otherProps
    } = props;
    return (
        <Box
            ref={ref}
            {...otherProps}
            sx={[
                {
                    display: 'flex',
                    flexDirection: direction ?? flexDirection ?? 'row',
                    alignItems: align ?? alignItems ?? 'initial',
                    justifyContent: justify ?? justifyContent ?? 'initial',
                    flexWrap: wrap ?? flexWrap ?? 'nowrap',
                },
                ...(Array.isArray(otherProps.sx)
                    ? otherProps.sx
                    : [otherProps.sx]),
            ]}
        />
    );
});

Flex.displayName = 'Flex';

export default Flex;
